import { createContext, Dispatch, SetStateAction } from "react";
import "../index.css";
import React, { useState } from "react";
type themeType = "light" | "dark";

interface ThemeInterface {
  theme: string;
  setTheme: Dispatch<SetStateAction<themeType>>;
}

export const ThemeContext = createContext<ThemeInterface>({
  theme: "light",
  setTheme: () => {},
});
const savedTheme = localStorage.getItem("RingconnectTheme") || "light";
const appTheme =
  savedTheme !== "light" && savedTheme !== "dark"
    ? "light"
    : savedTheme === "dark"
    ? "dark"
    : "light";
const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  const [theme, setTheme] = useState<themeType>(appTheme);
  document.documentElement.setAttribute("data-theme", theme);
  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
